import { createSlice } from "@reduxjs/toolkit";
import { TripOptionStatus_Enum } from "services/sale/common/enums";
import { Point, StopMinutesItem } from "services/sale/common/types";
import { PaymentMethods_Enum } from "../types";
import { boolean } from "yup";

interface location {
  isOrigin?: boolean;
  point: Point;
  address: string;
  priority: number;
  status?: TripOptionStatus_Enum;
  clientPriority: number;
}
interface Payment_Model {
  balance?: number;
  salePrice?: number;
  prepayment?: number;
  organizationPay?: number;
  needCharge?: number;
  defaultChoice?: PaymentMethods_Enum;
}

interface IMain {
  // نمایش تغییر روش پرداخت
  isShowChangePaymentMethod: boolean;
  unitId: number;
  // Main data
  sourcePoint?: Point;
  sourceAddress?: string;
  pickUpLocationId?: number;
  destinationPoint?: Point;
  destinationAddress?: string;
  dropOffLocationId?: number;
  stopMinutesItems: StopMinutesItem[];
  maxExtraDestinations?: number;
  humanCapacity?: number;
  baggageCapacity?: number;
  extraBaggageCapacity?: number;
  tripOptionPrice?: number;
  // Points
  locations: location[];
  // Options
  extraBaggage?: {
    status: TripOptionStatus_Enum;
    value: number;
    id: number;
  };
  baggageTransportaion?: {
    status: TripOptionStatus_Enum;
    value: number;
    id: number;
  };
  stopMinutes?: {
    status: TripOptionStatus_Enum;
    value: string;
    id: number;
  };
  // Edit
  editTarget?: any;
  // Change option
  changingOptionTarget?: any;
  // Options main value
  optionsMainValue: {
    extraBaggage?: { value: number; id: number; status: TripOptionStatus_Enum };
    baggageTransportaion?: {
      value: number;
      id: number;
      status: TripOptionStatus_Enum;
    };
    stopMinutes?: { value: number; id: number; status: TripOptionStatus_Enum };
  };

  reFetch?: boolean;
  // paymeny
  paymentModel?: Payment_Model;
}

const initialState: IMain = {
  unitId: null!,
  optionsMainValue: {},
  locations: [],
  changingOptionTarget: null,
  extraBaggage: null!,
  baggageTransportaion: null!,
  baggageCapacity: 0,
  extraBaggageCapacity: 0,
  stopMinutes: null!,
  stopMinutesItems: [],
  isShowChangePaymentMethod: false,
};

const mainSlice = createSlice({
  name: "main",
  initialState: initialState,
  reducers: {
    //_______________________________
    //اپدیت داده ها
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
    //_______________________________
    cleareData: (state, action) => {
      state = {
        unitId: null!,
        optionsMainValue: {},
        locations: [],
        changingOptionTarget: null,
        extraBaggage: null!,
        baggageTransportaion: null!,
        baggageCapacity: 0,
        extraBaggageCapacity: 0,
        stopMinutes: null!,
        stopMinutesItems: [],
        isShowChangePaymentMethod: false,
      } as IMain;
      return state;
    },
    // Locations --START
    initialLocations: (state, action) => {
      state.locations = [...action.payload];
      return state;
    },
    addLocation: (state, action) => {
      state.locations.push(action.payload);

      return state;
    },
    removeLocaiton: (state, action) => {
      state.locations = state.locations.filter(
        (location) => location.priority !== action.payload.priority
      );

      state.locations.forEach((location, index) => {
        if (location.priority > 0) {
          location.clientPriority = index - 1;
        }
      });
      return state;
    },
    updateLocation: (state, action) => {
      const updatedLocations = state.locations.find(
        (item) => item.priority === state.editTarget.priority
      );

      if (updatedLocations) {
        updatedLocations.address = action.payload.address;
        updatedLocations.point = action.payload.point;
        updatedLocations.status = undefined;
      }

      return state;
    },
    setEditTarget: (state, action) => {
      state.editTarget = action.payload;
      return state;
    },
    // Locations --END

    // Extra baggage --START
    setExtraBaggage: (state, action) => {
      state.extraBaggage = action.payload;

      return state;
    },
    // Extra baggage --END

    // Baggage transportaion --START
    setBaggageTransportaion: (state, action) => {
      state.baggageTransportaion = action.payload;

      return state;
    },
    // Baggage transportaion --END

    // Baggage transportaion --START
    setStopMinutes: (state, action) => {
      state.stopMinutes = action.payload;

      return state;
    },

    // Baggage transportaion --END

    setChangingOptionTarget: (state, action) => {
      state.changingOptionTarget = action.payload;
    },

    // Main options value
    setOptionMainValue: (state, action) => {
      state.optionsMainValue = { ...state.optionsMainValue, ...action.payload };

      return state;
    },

    reFetch: (state) => {
      state.reFetch = !state.reFetch;
      return state;
    },

    setUnitId: (state, action) => {
      state.unitId = action.payload;
    },
    //payment
    setPaymentModel: (state, action) => {
      state.paymentModel = action.payload;

      return state;
    },
  },
});

export default mainSlice;
